(() => {
  const main = document.querySelector('#MainContent[data-monolyt-information-page]');
  if (!main) return;

  const policyContainer = main.querySelector('.shopify-policy__container');
  const policyBody = policyContainer?.querySelector('.shopify-policy__body');
  const pageWrapper = main.querySelector('.section-content-wrapper');
  const pageBody = [...(pageWrapper?.children || [])].find((element) => element.querySelector('rte-formatter'));
  const faqBody = main.querySelector('[data-monolyt-information-body]');
  const body = policyBody || pageBody || faqBody;
  const shell = policyContainer || pageWrapper || faqBody;
  if (!body || !shell) return;

  const isFaq = body.matches('[data-monolyt-information-body]');
  main.classList.add('monolyt-legal-page');
  if (!isFaq) body.classList.add('monolyt-legal-body');

  const getLabel = (element) => {
    if (element.matches('.monolyt-faq__item')) {
      return element.querySelector('summary span')?.textContent.replace(/\s+/g, ' ').trim() || '';
    }
    if (element.matches('.monolyt-legal-body__anchor')) {
      return element.firstElementChild?.textContent.replace(/\s+/g, ' ').trim() || '';
    }
    return element.textContent.replace(/\s+/g, ' ').trim();
  };

  function hideRedundantSourceOutline(contentBody, outlineHeadings) {
    const outlineLabels = new Set(['übersicht', 'overview']);
    const sourceContainer = contentBody.querySelector('rte-formatter') || contentBody;
    const sourceHeading = [...sourceContainer.children].find((element) => {
      if (element.tagName !== 'P') return false;
      const label = element.textContent.replace(/\s+/g, ' ').trim().toLocaleLowerCase();
      return outlineLabels.has(label);
    });
    if (!sourceHeading) return false;

    const outlineStopWords = new Set([
      'and', 'for', 'from', 'of', 'on', 'or', 'the', 'to', 'with',
      'auf', 'das', 'den', 'der', 'des', 'die', 'ein', 'eine', 'im', 'in', 'oder', 'und', 'von', 'zu', 'zum', 'zur',
    ]);
    const getOutlineEntry = (element) => {
      const match = getLabel(element).match(/^•?\s*(\d{1,2})[.)]\s+(.+)$/);
      if (!match) return null;

      const tokens = match[2]
        .toLocaleLowerCase(document.documentElement.lang || 'de')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9ß]+/g, ' ')
        .trim()
        .split(/\s+/)
        .filter((token) => token.length > 1 && !outlineStopWords.has(token));
      return { number: Number.parseInt(match[1], 10), tokens };
    };
    const headingEntries = outlineHeadings.map(getOutlineEntry).filter(Boolean);

    const sourceOutlineNodes = [sourceHeading];
    const sourceEntries = [];
    let candidate = sourceHeading.nextElementSibling;
    while (candidate && !candidate.matches('h1, h2, h3, [role="heading"]')) {
      const label = candidate.textContent.replace(/\s+/g, ' ').trim();
      const outlineEntry = getOutlineEntry(candidate);
      if (label && !outlineEntry) break;
      if (outlineEntry) sourceEntries.push(outlineEntry);
      sourceOutlineNodes.push(candidate);
      candidate = candidate.nextElementSibling;
    }

    const hasUniqueNumbers = (entries) => new Set(entries.map((entry) => entry.number)).size === entries.length;
    const labelsCorrespond = (sourceEntry, headingEntry) => {
      if (sourceEntry.number !== headingEntry.number || !sourceEntry.tokens.length || !headingEntry.tokens.length) return false;
      const headingTokens = new Set(headingEntry.tokens);
      const sharedTokens = new Set(sourceEntry.tokens.filter((token) => headingTokens.has(token))).size;
      return sharedTokens / Math.max(sourceEntry.tokens.length, headingEntry.tokens.length) >= 0.66;
    };
    const matchesDocumentOutline = sourceEntries.length >= 2
      && sourceEntries.length === headingEntries.length
      && hasUniqueNumbers(sourceEntries)
      && hasUniqueNumbers(headingEntries)
      && sourceEntries.every((entry, index) => labelsCorrespond(entry, headingEntries[index]));
    if (!matchesDocumentOutline) return false;

    sourceOutlineNodes.forEach((node) => {
      node.hidden = true;
      node.dataset.monolytRedundantOutline = 'true';
    });
    return true;
  }

  let headings = isFaq
    ? [...body.querySelectorAll('.monolyt-faq__item')].filter((item) => getLabel(item))
    : [...body.querySelectorAll('h1, h2, h3')].filter((heading) => heading.textContent.trim());

  if (!isFaq && headings.length < 2) {
    headings = [...body.querySelectorAll('p')].filter((paragraph) => {
      const label = paragraph.textContent.replace(/\s+/g, ' ').trim();
      return label.length <= 140 && /^\d{1,2}[.)]\s+\S/.test(label);
    });

    headings.forEach((heading) => {
      heading.classList.add('monolyt-legal-body__generated-heading');
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '2');
    });
  }

  if (!isFaq && headings.length < 2) {
    headings = [...body.querySelectorAll('p')].filter((paragraph) => {
      const strong = paragraph.firstElementChild;
      const label = paragraph.textContent.replace(/\s+/g, ' ').trim();
      const headingLabel = strong?.textContent.replace(/\s+/g, ' ').trim() || '';
      return strong?.tagName === 'STRONG' && headingLabel.length > 0 && headingLabel.length <= 80 && label.length <= 220;
    });

    headings.forEach((heading) => heading.classList.add('monolyt-legal-body__anchor'));
  }

  if (headings.length === 0) return;

  const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
  const slugify = (value) =>
    value
      .toLocaleLowerCase(document.documentElement.lang || 'de')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'abschnitt';

  headings.forEach((heading, index) => {
    if (!heading.id) {
      const base = slugify(getLabel(heading));
      let id = base;
      let suffix = 2;
      while (usedIds.has(id)) id = `${base}-${suffix++}`;
      heading.id = id;
      usedIds.add(id);
    }
    heading.dataset.monolytTocIndex = String(index + 1);
  });

  shell.classList.add('monolyt-legal-layout', 'monolyt-legal-layout--with-toc');
  main.classList.add('monolyt-legal-page--with-toc');

  const nav = document.createElement('nav');
  nav.className = 'monolyt-legal-toc';
  nav.setAttribute('aria-label', document.documentElement.lang.startsWith('de') ? 'Inhaltsverzeichnis' : 'Table of contents');

  const disclosure = document.createElement('details');
  disclosure.className = 'monolyt-legal-toc__details';
  const disclosureId = `MonolytLegalToc-${Math.random().toString(36).slice(2, 9)}`;
  disclosure.id = disclosureId;

  const summary = document.createElement('summary');
  summary.className = 'monolyt-legal-toc__title';
  const title = document.createElement('span');
  title.textContent = document.documentElement.lang.startsWith('de') ? 'Übersicht' : 'Overview';
  const count = document.createElement('span');
  count.className = 'monolyt-legal-toc__count';
  count.textContent = `${headings.length} ${document.documentElement.lang.startsWith('de') ? 'Abschnitte' : 'sections'}`;
  summary.append(title, count);
  disclosure.append(summary);

  const list = document.createElement('ol');
  const links = [];
  headings.forEach((heading) => {
    const item = document.createElement('li');
    if (heading.tagName === 'H3') item.classList.add('monolyt-legal-toc__subitem');
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = getLabel(heading).replace(/^\d{1,2}[.)]\s+/, '');
    link.addEventListener('click', () => {
      links.forEach((candidate) => candidate.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'location');
      if (heading.matches('details')) heading.open = true;
      if (window.matchMedia('(max-width: 989px)').matches) disclosure.open = false;
      window.setTimeout(() => {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }, 0);
    });
    links.push(link);
    item.append(link);
    list.append(item);
  });
  disclosure.append(list);
  nav.append(disclosure);

  if (isFaq) {
    body.querySelector('.monolyt-faq__header')?.append(nav);
  } else {
    body.before(nav);
    hideRedundantSourceOutline(body, headings);
    window.requestAnimationFrame(() => hideRedundantSourceOutline(body, headings));
  }

  const desktop = window.matchMedia('(min-width: 990px)');
  const syncDisclosure = () => {
    disclosure.open = true;
  };
  syncDisclosure();
  desktop.addEventListener?.('change', syncDisclosure);

  const currentHashTarget = window.location.hash ? document.getElementById(window.location.hash.slice(1)) : null;
  if (currentHashTarget?.matches('details')) currentHashTarget.open = true;

  if (!('IntersectionObserver' in window)) return;
  const setCurrent = (target) => {
    links.forEach((link) => {
      if (link.hash === `#${target.id}`) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };
  const observer = new IntersectionObserver(
    (entries) => {
      const hashTarget = window.location.hash
        ? headings.find((heading) => `#${heading.id}` === window.location.hash)
        : null;
      if (hashTarget) {
        setCurrent(hashTarget);
        return;
      }

      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setCurrent(visible[0].target);
    },
    { rootMargin: '-18% 0px -70% 0px' }
  );
  headings.forEach((heading) => observer.observe(heading));
})();
